module.exports = __webpack_public_path__ + "img/warehouse_green.f4a9ec36.png";